import { Box, Close } from '.'

export const Drawer = ({ open, onClose, children, ...props }) => {
  return <>
    <Box
      position="fixed"
      inset
      onClick={onClose}
      zIndex={open ? 2001 : -1}
    />
    <Box
      className="drawer"
      column
      position="fixed"
      top={0}
      fullHeight
      maxHeight="100dvh"
      overflowY="scroll"
      width={500}
      maxWidth="100%"
      background="white"
      right={open ? 0 : -500}
      transition={0.5}
      zIndex={2002}
      {...props}
    >
      <Box position="absolute" top={0} right={0} p={16} onClick={onClose} cursor="pointer">
        <Close size={24} fill="black" />
      </Box>
      {children}
    </Box>
  </>
}